import { render, staticRenderFns } from "./workerNewPage.vue?vue&type=template&id=4088db5e&"
import script from "./workerNewPage.vue?vue&type=script&lang=ts&"
export * from "./workerNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports